import type { OrderQuotaConsumer } from "~/modules/quota/api/quota/quotaTypes.ts";

// A consumer takes bookings when its quota is bookable and its own booking toggle is on.
// The time tracking form applies the same check (quotaTakesBookingOnDay in timeTrackingUtils.ts).
export function quotaConsumerTakesBookings(consumer: OrderQuotaConsumer): boolean {
	return consumer.quota.isBookable && consumer.timeTrackingEnabled;
}

// Two usable periods overlap when they share at least one day. A null bound is open.
function usablePeriodsOverlap(a: OrderQuotaConsumer["quota"], b: OrderQuotaConsumer["quota"]): boolean {
	const aFrom = a.usableFrom?.slice(0, 10);
	const aUntil = a.usableUntil?.slice(0, 10);
	const bFrom = b.usableFrom?.slice(0, 10);
	const bUntil = b.usableUntil?.slice(0, 10);

	const aStartsAfterB = aFrom !== undefined && bUntil !== undefined && aFrom > bUntil;
	const bStartsAfterA = bFrom !== undefined && aUntil !== undefined && bFrom > aUntil;

	return !aStartsAfterB && !bStartsAfterA;
}

// The consumers of one order whose quotas can take the same tracking. With two or more of them the
// time tracking form disables the quota switch, so the order needs a fix on the quota details page.
export function getOverlappingBookableQuotaConsumers(consumers: OrderQuotaConsumer[]): OrderQuotaConsumer[] {
	const bookableConsumers = consumers.filter(quotaConsumerTakesBookings);

	return bookableConsumers.filter((consumer) => bookableConsumers.some((other) => other.id !== consumer.id
		&& usablePeriodsOverlap(consumer.quota, other.quota)));
}
